module.exports = __webpack_public_path__ + "static/media/temujin-treasures.45c162ed.gif";